<template>
  <form @change="logChangeData">
    <div class="setting_content">
      <div class="setting_content_main">
        <h2 class="setting_content_title">
          {{ labelsProperties.TAB_HEADER }}
        </h2>
        <p class="setting_unit_annotation">
          {{ labelsProperties.SELECT_OPTION_ANNOTATION }}
        </p>
        <div class="setting_unit" v-if="hp_renkei_job === 1">
          <p class="setting_unit_title">
            {{ labelsProperties.PROGRESS_SETTING }}
          </p>
          <p class="setting_unit_explain">
            {{ labelsProperties.PROGRESS_SETTING_EXPLAIN }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelsProperties.PROGRESS_STEP }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_form_select_wrapper">
                <select
                  class="setting_form_select"
                  v-model="displaySetting.progressStep"
                >
                  <option
                    v-for="(stepState, index) in masterStepStates.filter(stepState => stepState && stepState.show)"
                    :key="index"
                    v-bind:value="stepState.choiceId"
                    v-text="stepState.choiceDisplayName ? stepState.choiceDisplayName : stepState.choiceName"
                  >
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelsProperties.MANAGER }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_form_select_wrapper">
                <select
                    class="setting_form_select"
                    v-model="displaySetting.manager"
                >
                  <option
                      v-for="(user, index) in users.filter(user => user && user.display_name)"
                      :key="index"
                      v-bind:value="user.id"
                      v-text="user.display_name"
                  >
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="setting_unit" v-if="hp_renkei_entry === 1">
          <p class="setting_unit_title">
            {{ labelsProperties.OTHER_SETTING }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelsProperties.RECRUITING_MEDIUM }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_form_select_wrapper">
                <select
                  class="setting_form_select"
                  v-model="displaySetting.inHouseHP"
                >
                  <option
                    v-for="(media, index) in masterMedia.filter(media => media && media.show)"
                    :key="index"
                    v-bind:value="media.choiceId"
                    v-text="media.choiceDisplayName ? media.choiceDisplayName : media.choiceName"
                  >
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ labelsProperties.PRINT_BUTTON }}</p>
            <div class="setting_unit_form">
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySetting.print"
                    value="true"
                    id="is_print_0"
                    checked="checked"
                />
                <label for="is_print_0" class="setting_form_radio_text">
                  {{ labelsProperties.DISPLAY }}
                </label>
              </label>
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySetting.print"
                    value="false"
                    id="is_print_1"
                />
                <label for="is_print_1" class="setting_form_radio_text">
                  {{ labelsProperties.NOT_DISPLAY }}
                </label>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import labelsProperties from "../../../properties/entry_screen/advance_setting_tab/advance-setting-labels.json";
export default {
  name: "AdvanceSetting",
  props: ["masterStepStates", "users", "displaySetting", "masterMedia", "hp_renkei_job", "hp_renkei_entry"],
  data() {
    return {
      labelsProperties: labelsProperties,
    };
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },
  },
};
</script>
